/** Shared per-service display metadata — extend when a new ServiceModule lands */
export const SERVICE_LABELS: Record<string, string> = {
  microsoft365: 'Microsoft 365',
  zoom: 'Zoom',
  miro: 'Miro',
  teamflect: 'TeamFlect',
  atlassian: 'Atlassian',
}

/** How each service ingests data — drives which control ServiceConfig.tsx shows */
export const SERVICE_INGESTION: Record<string, 'api' | 'csv' | 'manual'> = {
  microsoft365: 'api',
  zoom: 'csv',
  miro: 'csv',
  teamflect: 'csv',
  atlassian: 'api',
}

/**
 * Services whose ServiceModule needs Key Vault (third-party API tokens) and therefore only
 * runs from timer/ — api/'s Static Web App Free tier has no Managed Identity support, so it can
 * never reach Key Vault. These have no manual "Sync now" trigger; they only sync on timer/'s
 * daily schedule. See docs/ARCHITECTURE.md. `atlassian` is the first real entry (its Admin API
 * key lives in Key Vault).
 */
export const TIMER_ONLY_SERVICES = new Set<string>(['atlassian'])

/** How each ingestion method is shown as a small lozenge badge — Sidebar and Dashboard both use this */
export const INGESTION_BADGE: Record<'api' | 'csv' | 'manual', { label: string; color: 'success' | 'warning' | 'informative' }> = {
  api: { label: 'API', color: 'success' },
  csv: { label: 'CSV', color: 'warning' },
  manual: { label: 'MANUAL', color: 'informative' },
}
